import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { getInitials } from "../utils/util";
import moment from "moment";
import axios from "axios";
import { useSelector } from "react-redux";
import Select from "react-select";
import InfiniteScroll from "react-infinite-scroll-component";
import ConfirmBox from "./modals/ConfirmBox";
import apiClient from "../apiClient";
import { DELETE_MACHINE_RESPONSE } from "../apiClient/endpoints";

const SiteUserResponseList = ({ setResponseLenght, setUserResponse }) => {
  const { uuid } = useParams();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const API_URL = configData.config.API_URL;
  const [loading, setLoading] = useState(true);
  const [responses, setResponses] = useState([]);
  const [siteOptions, setSiteOptions] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const limit = 25;
  const [openConfirmBox, setOpenConfirmBox] = useState(false);
  const [selectedResponse, setSelectedResponse] = useState(null);

  const fetchResponses = async (pageNumber = 1, isFilterChange = false) => {
    try {
      const { data } = await axios.post(
        `${API_URL}/api/site/responses/list/${uuid}?page=${pageNumber}&limit=${limit}`,
        {
          ...(selectedSites?.length && { sites: selectedSites.map((e) => e.value) }),
        },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const newResponses = data?.data;
      if (pageNumber === 1) {
        setResponseLenght(newResponses?.totalCount);
        const siteNames = [...new Set(newResponses?.list.map((e) => e?.site?.name).filter(Boolean))];
        if (!siteOptions.length) {
          setSiteOptions(
            siteNames.length > 0
              ? siteNames.map((name) => ({ label: name, value: name }))
              : [{ label: "No Option", value: "no-option" }]
          );
        }
      }

      if (isFilterChange || pageNumber === 1) {
        setResponses(newResponses?.list);
        // setUserResponse(newResponses?.list);
      } else {
        setResponses((prev) => [...prev, ...newResponses?.list]);
        // setUserResponse((prev) => [...prev, ...newResponses?.list]);
      }

      if (newResponses?.list.length < limit) {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Fetch error", error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllResponse = async () => {
    try {
      const { data } = await axios.post(
        `${API_URL}/api/site/responses/list/${uuid}`,
        {
          ...(selectedSites?.length && { sites: selectedSites.map((e) => e.value) }),
        },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setUserResponse(data?.data?.list || []);
    } catch (error) {
      console.log(error, "error in fetching all response");
    }
  };

  const deleteResponse = async () => {
    try {
      await apiClient.post(`${API_URL}${DELETE_MACHINE_RESPONSE}/${selectedResponse}`);
    } catch (error) {
      console.log(error.message);
    } finally {
      fetchResponses();
    }
  };

  useEffect(() => {
    setLoading(true);
    setResponses([]);
    setPage(1);
    setHasMore(true);
    fetchResponses(1, true);
    fetchAllResponse();
  }, [uuid, selectedSites]);

  const fetchNext = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchResponses(nextPage);
  };

  return (
    <>
      {loading ? (
        <div className="table-responsive workflowtb mt-2">
          <table className="table align-middle table-nowrap mb-0">{/* Skeleton UI */}</table>
        </div>
      ) : (
        <>
          {responses.length > 0 ? (
            <>
              <div className="row justify-content-end">
                <div className="col-md-12 d-flex align-items-center justify-content-end">
                  <div className="d-flex justify-content-end mb-2 selectSiteParent" style={{ width: "max-content" }}>
                    <Select
                      value={selectedSites}
                      onChange={setSelectedSites}
                      options={siteOptions}
                      isMulti
                      placeholder="Select a site"
                      className="w-100"
                    />
                  </div>
                </div>
              </div>

              <div className="table-responsive workflowtb mt-2">
                <InfiniteScroll dataLength={responses.length} next={fetchNext} hasMore={hasMore}>
                  <table className="table align-middle table-nowrap mb-0">
                    <thead>
                      <tr>
                        <th className="text-center">S.No.</th>
                        <th>User</th>
                        <th>Designation</th>
                        <th>Site Name</th>
                        <th>Floor</th>
                        <th className="text-center">Date & Time</th>
                        <th className="text-center">Health Status</th>
                        <th className="text-center">Response</th>
                        {userData?.user?.permissions.includes("MACHINE.ADD") && <th className="text-center">Delete</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {responses.map((response, index) => (
                        <tr key={response.uuid}>
                          <td className="text-center">{index + 1}</td>
                          <td>
                            <div className="nameemail">
                              {response?.avatar ? (
                                <img
                                  src={response.avatar}
                                  alt={response.name || "Profile"}
                                  title={response.name || ""}
                                  className="profilepik"
                                  referrerPolicy="no-referrer"
                                />
                              ) : (
                                <div className="avatar-placeholder">{getInitials(response.name).toUpperCase()}</div>
                              )}
                              <span>
                                <p>{response.name}</p>
                                <p>{response.email}</p>
                              </span>
                            </div>
                          </td>
                          <td>{response?.designation || "N/A"}</td>
                          <td>{response?.site?.name}</td>
                          <td>{response?.metaData?.floor || "N/A"}</td>
                          <td>
                            <div className="datetime">
                              <p>{moment(response.createdAt).format("DD-MM-YYYY")}</p>
                              <p>{moment(response.createdAt).format("HH:mm")}</p>
                            </div>
                          </td>
                          <td className={`text-center ${response.health === 100 ? "good" : "bad"}`}>
                            <span>{Math.abs(response.health).toFixed(2)}%</span>
                          </td>
                          <td className="text-center">
                            <Link to={`/site/user-response/${response.uuid}`}>View</Link>
                          </td>
                          {userData?.user?.permissions?.includes("MACHINE.ADD") && (
                            <td
                              className="text-center "
                              onClick={() => {
                                setSelectedResponse(() => response.uuid);
                                setOpenConfirmBox(true);
                              }}
                            >
                              <span className="deleteSpan"> Delete </span>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </InfiniteScroll>
              </div>
            </>
          ) : (
            <div className="row">
              <div className="px-4">
                <div className="first-event">No Response received yet!</div>
              </div>
            </div>
          )}
          <ConfirmBox
            isOpen={openConfirmBox}
            setIsOpen={setOpenConfirmBox}
            onClose={() => setSelectedResponse(null)}
            onSuccess={deleteResponse}
          />
        </>
      )}
    </>
  );
};

export default SiteUserResponseList;
